import React, { Suspense, useState } from "react";
import { Icon, Intent } from "./externals";
import { Drawer, DrawerSize } from "./Drawer";
import "./FocusHelp.scss";
import { Loading } from "./Loading";
const ReactMarkdown = React.lazy(() => import("react-markdown"));
export const FocusHelp = ({ helpText }) => {
    const [isHelpOpen, setIsHelpOpen] = useState(false);
    const closeHelp = () => setIsHelpOpen(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Icon, { className: "focusHelp__icon", icon: "help", intent: Intent.NONE, onClick: () => setIsHelpOpen(!isHelpOpen) }),
        React.createElement(Drawer, { title: "Showing the help data", onClose: closeHelp, isOpen: isHelpOpen, size: DrawerSize.SMALL },
            React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
                React.createElement(ReactMarkdown, null, helpText)))));
};
//# sourceMappingURL=FocusHelp.js.map